/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import styled from "styled-components";
import EditorLabel from "editor/components/EditorLabel";
import { PropListItem, PropLabel } from "./styles";

const IconList = styled.div`
  display: flex;
`;

const IconItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 24px;
  cursor: pointer;
  user-select: none;

  &:not(:last-child) {
    margin-right: 10px;
  }
`;

class RadioSelectIcon extends Component {
  constructor() {
    super();
    this.state = {
      value: null
    };
  }

  componentDidMount() {
    const { currentValue } = this.props;
    this.setState({ value: currentValue });
  }

  optionChange = value => {
    const { name, updaterFn } = this.props;
    this.setState({ value });
    updaterFn({ prop: name, value });
  };

  optionsHandler = () => {
    const { options } = this.props;
    const { value } = this.state;

    return options.map(item => {
      const color = item.value === value ? "44ADF8" : "BBBBBB";
      // eslint-disable-next-line no-template-curly-in-string
      const colorIcon = item.icon.replace("${color}", color);

      return (
        <IconItem onClick={() => this.optionChange(item.value)}>
          <img src={`${colorIcon}`} width="14" />
        </IconItem>
      );
    });
  };

  render() {
    const { label, locale, tooltip } = this.props;
    const tooltipText = (tooltip && tooltip[locale]) || null;

    return (
      <PropListItem>
        <PropLabel>
          <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
        </PropLabel>
        <IconList>{this.optionsHandler()}</IconList>
      </PropListItem>
    );
  }
}

export default RadioSelectIcon;
